import { buildDefaultNewsFeedPreferences, type NewsFeedPreferences } from './newsFeedDefaults';

let cached: NewsFeedPreferences = buildDefaultNewsFeedPreferences();

export function setNewsFeedPreferences(prefs: NewsFeedPreferences): void {
  cached = prefs;
}

export function getNewsFeedPreferences(): NewsFeedPreferences {
  return cached;
}
